export default class TrackerBing {

    constructor() {
        this.enabled = false;
    }

    load() {
        if (!this.enabled) {
            this.enabled = true;
            (function (w, d, t, r, u) {
                var f, n, i;
                w[u] = w[u] || [], f = function () {
                    var o = {ti: "343027985"};
                    o.q = w[u], w[u] = new UET(o), w[u].push("pageLoad")
                }, n = d.createElement(t), n.src = r, n.async = 1, n.onload = n.onreadystatechange = function () {
                    var s = this.readyState;
                    s && s !== "loaded" && s !== "complete" || (f(), n.onload = n.onreadystatechange = null)
                }, i = d.getElementsByTagName(t)[0], i.parentNode.insertBefore(n, i)
            })(window, document, "script", "//bat.bing.com/bat.js", "uetq");
        }
    }

    sendOnPageLoad() {
        if (!this.enabled)
            return;

        if (window.trackerVar.montant_total > 0 && window.trackerVar.listing_google.length > 0) {
            window.uetq = window.uetq || [];
            window.uetq.push('event', 'clic', {"event_label": "Commande", "event_value": window.trackerVar.montant_total, "event_category": "achat", "revenue_value": window.trackerVar.montant_total, "currency": "EUR"});
        }
    }

}
